import { render, staticRenderFns } from "./SelfTips.vue?vue&type=template&id=c7b3f2d4&scoped=true&"
import script from "./SelfTips.vue?vue&type=script&lang=js&"
export * from "./SelfTips.vue?vue&type=script&lang=js&"
import style0 from "./SelfTips.vue?vue&type=style&index=0&id=c7b3f2d4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b3f2d4",
  null
  
)

export default component.exports